import { Heading2, Link, Stack, theme } from '@ovotech/element-v5';
import { Card } from '@ovotech/nebula';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  overflow: hidden;
`;

export const StyledHeading = styled(Heading2)`
  color: ${theme.color.surface.onSurface};
`;

export const StyledLink = styled(Link)`
  background-color: ${theme.color.brand.brand};
  border-color: ${theme.color.brand.brand};
`;

export const ImageMask = styled.div`
  width: 150px;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0; /* Prevents the Flexbox container from squishing the mask */
  transform: translateX(14%) translateY(27%) rotate(-15deg) scale(1.8);
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: rotate(15deg) translateX(-12%) translateY(-5%);
`;

export const Container = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const StyledStack = styled(Stack)`
  flex-grow: 1;
`;
